module.exports = __webpack_public_path__ + "static/media/nitsgr_logo.e15099aa.png";